<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/pqARQN/tc-custom/9780226182117.jpg?1730639438062" alt="This image is the cover for the book Great Movies III"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Great Movies III
      </h1>
      <p class="bookDescription body article font2">
        <p>Roger Ebert has been writing film reviews for the <i>Chicago Sun-Times</i> for over four decades now and his biweekly essays on great movies have been appearing there since 1996. As Ebert noted in the introduction to the first collection of those pieces, “They are not <i>the</i> greatest films of all time, because all lists of great movies are a foolish attempt to codify works which must stand alone. But it’s fair to say: If you want to take a tour of the landmarks of the first century of cinema, start here.<br/><br/> Enter <i>The Great Movies III</i>, Ebert’s third collection of essays on the crème de la crème of the silver screen, each one a model of critical appreciation and a blend of love and analysis that will send readers back to the films with a fresh set of eyes and renewed enthusiasm—or maybe even lead to a first-time viewing. From <i>The Godfather: Part II</i> to <i>Groundhog Day</i>, from <i>The Last Picture Show</i> to <i>Last Tango in Paris</i>, the hundred pieces gathered here display a welcome balance between the familiar and the esoteric, spanning Hollywood blockbusters and hidden gems, independent works and foreign language films alike. Each essay draws on Ebert’s vast knowledge of the cinema, its fascinating history, and its breadth of techniques, introducing newcomers to some of the most exceptional movies ever made, while revealing new insights to connoisseurs as well.<br/><br/> Named the most powerful pundit in America by <i>Forbes</i> magazine, and a winner of the Pulitzer Prize, Roger Ebert is inarguably the most prominent and influential authority on the cinema today. <i>The Great Movies III</i> is sure to please his many fans and further enhance his reputation as America’s most respected—and trusted—film critic.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Roger Ebert
      </h2>
      
      <p class="authorDescription body article"><B>Roger Ebert</B> is the Pulitzer Prize–winning film critic of the <I>Chicago Sun-Times</I>. He is the author of numerous books on film, including <I>The Great Movies</I>, <I>The Great Movies II</I>, <I>Awake in the Dark: The Best of Roger Ebert</I>, and <I>Scorsese by Ebert</I>, the last two titles published by the University of Chicago Press.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The University of Chicago Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?c6eb5dd8